<template>
  <div>
    <el-dialog
      v-model="options.show"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :width="options.width ?? '80%'"
      :title="options.title ?? '弹窗标题'"
      @close="handleClick('close')"
      :top="options.top ?? '60px'"
      :lock-scroll="true"
    >
      <template v-if="options.header ?? true" #header>
        <div class="flex align-center">
          <span class="margin-right-10">{{ options.title }}</span>
          <slot name="header"></slot>
          <div
            class="flex align-center"
            v-if="options.button && options.button === 'header'"
          >
            <cu-button
              type="save"
              @click="handleClick('confirm')"
              :label="options.confirmText ?? '保存'"
            ></cu-button>
            <cu-button
              class="margin-left-10"
              type="cancel"
              @click="handleClick('close')"
              :label="options.cancelText ?? '取消'"
            ></cu-button>
          </div>
        </div>
      </template>
      <slot></slot>
      <template
        v-if="(options.button ?? true) && options.button !== 'header'"
        #footer
      >
        <div class="dialog-footer flex justify-between align-center">
          <div>
            <slot name="foot"></slot>
          </div>
          <div class="flex align-center">
            <cu-button
              type="save"
              @click="handleClick('confirm')"
              :label="options.confirmText ?? '保存'"
            ></cu-button>
            <cu-button
              class="margin-left-10"
              type="cancel"
              @click="handleClick('close')"
              :label="options.cancelText ?? '取消'"
            ></cu-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import CuButton from "@/components/button/CuButton";
export default {
  name: "cu-dialog",
  components: { CuButton },
  props: {
    options: {
      type: Object,
      default: () => {
        return {
          show: false,
          cancelText: "取消",
          confirmText: "确定",
          button: "footer",
        };
      },
    },
  },
  methods: {
    handleClick(type) {
      this.$emit(type);
    },
  },
};
</script>

<style scoped></style>
